(function () {
    'use strict';

    angular
        .module('recommendationEditRoutes', [
            'recommendationEditModule'
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {
        $stateProvider

            .state('recommendation', {
                url: '/Recommendation',
                abstract: true,
                data: {
                    breadcrumb: [{
                            getBreadcrumb: function (resolves) {
                                // Audit Mandate
                                if(resolves.recommendation.RecomBusinessUnit.Code == 'InternalAudit'){
                                    return {
                                        cssIcon: 'fa fa-road',
                                        title: resolves.ancesters.observation.GovernanceProcess.ShortNameAndFiscalYear,
                                        stateName: 'auditMandateEdit',
                                        stateParams: {
                                            AuditMandateID: resolves.ancesters
                                                .auditMandate.AuditMandateID                                            
                                        }
                                    }
                                }

                                if (resolves.ancesters.observation.GovernanceProcess) {
                                    return {
                                        cssIcon: 'fa fa-road',
                                        title: resolves.ancesters.observation.GovernanceProcess.ShortNameAndFiscalYear,
                                        stateName: 'auditMandateEdit',
                                        stateParams: {
                                            AuditMandateID: resolves.auditMandate.AuditMandateID
                                        }
                                    }
                                }

                                if (resolves.ancesters.observation.ObservationContainer) {                                    
                                    let stateName = null;

                                    if(resolves.ancesters.observation.RecomBusinessUnit.Code == "InformationSecurityMandate"){
                                        stateName = "newInformationSecurityMandateSearch";
                                    } else if (resolves.ancesters.observation.RecomBusinessUnit.Code == "AssessmentRecommendation"){
                                        stateName = "newInformationSecurityProviderSearch";
                                    } else if(resolves.ancesters.observation.RecomBusinessUnit.Code == "DerogationException"){
                                        stateName = "newGovernanceDerogationSearch";
                                    } else if (resolves.ancesters.observation.RecomBusinessUnit.Code == "BTGMandate") {
                                        stateName = "newGovernanceMandateSearch";
                                    }
                                                                         
                                    return {
                                        cssIcon: 'fa fa-road',
                                        title: resolves.ancesters.observation.ObservationContainer.TitleEN,
                                        stateParams: {
                                            facets: 'ObservationContainerIdForSearch=' + 
                                                                    resolves.ancesters.observation
                                                                    .ObservationContainer
                                                                    .ObservationContainerID
                                        },                                    
                                        stateName: stateName
                                    }
                                }

                                // Control Test
                                if (resolves.controlTest && resolves.controlTest.ControlTestID) {
                                    return {
                                        cssIcon: 'fa fa-pencil-square-o',
                                        title: 'Control Test',
                                        stateName: 'control.controlTests.edit',
                                        stateParams: {
                                            ControlID: resolves.controlTest.ControlID,
                                            ControlTestID: resolves.controlTest.ControlTestID
                                        }
                                    }
                                }

                                // ODD Campaign
                                if (resolves.observation.ODDCampaignID) {
                                    return {
                                        cssIcon: 'fa fa-bullhorn',
                                        title: resolves.oddCampaign.TitleEN,
                                        stateName: 'odd.externalPartyEdit.campaign',
                                        stateParams: {
                                            CampaignTypeCode: resolves.businessUnit.CampaignType.Value.toLowerCase(),
                                            BusinessUnitCode: resolves.oddCampaign.ODDBusinessUnitCode,
                                            ODDExternalPartyID: resolves.oddCampaign.ODDExternalPartyID,
                                            ODDCampaignID: resolves.oddCampaign.ODDCampaignID
                                        }
                                    }
                                }
                            }
                        }, {
                            getBreadcrumb: function (resolves) { 
                                return {
                                    title: resolves.ancesters.observation.Description,
                                    cssIcon: 'fa fa-area-chart',
                                    usingHistoryCtxt: false,
                                    stateName: 'observation.edit',
                                    stateParams: {
                                        ObservationID: resolves.ancesters.observation.ObservationID
                                    }
                                }
                            }
                        },
                    ]
                },
           
                views: {
                    '': {
                        template: '<div ui-view="breadcrumbs" class="breadcrumbs-container"></div><div ui-view="mainContent" class="business-planning"></div>'
                    },
                    'breadcrumbs@recommendation': {
                        templateUrl: require('./recommendationBreadcrumbs.tpl.html')
                    }
                }
            })

            // Recommendation Edit
            .state('recommendation.edit', {
                url: '/{RecommendationID:int}',
                params: historyCtxtServiceProvider.getStateParamsConfig(),
                data: { 
                    breadcrumb: {
                        titlePath: 'recommendation.Name',
                        cssIcon: 'fa fa-lightbulb-o',
                        stateReload: true
                    }
                },
                resolve: {
                    recommendation: ['$stateParams', 'grcRecommendationService', function ($stateParams, service) {
                        return service.getRecommendation($stateParams.RecommendationID);
                    }],

                    ancesters: ['$stateParams', 'grcRecommendationService', 'grcObservationService', 'auditMandateService', function ($stateParams, recomService, 
                        observationService, auditMandateService) {

                        let recom = null;
                        let observation = null;
                        let observationContainer = null;

                        return recomService
                            .getRecommendation($stateParams.RecommendationID)
                            .then(retrievenRecom => {
                                recom = retrievenRecom;
                                return observationService
                                        .getObservation(retrievenRecom.RecomObservations[0].ObservationID)
                            })
                            .then(retrievenObs => {
                                observation = retrievenObs;
                                observationContainer = retrievenObs.ObservationContainer;

                                if(observation.GovernanceProcessID){
                                    return auditMandateService
                                            .getAuditMandateByGovernanceProcessID(observation.GovernanceProcessID)
                                            .then(auditMandate => {
                                               
                                                return {
                                                    observationContainer: observationContainer,
                                                    observation: observation,
                                                    recomendation: recom,
                                                    auditMandate: auditMandate
                                                }
                                            })
                                }

                                return {
                                    observationContainer: observationContainer,
                                    observation: observation,
                                    recomendation: recom
                                }
                            });
                    }],

                    canViewObservation: ['authenticatedUser', 'permissionService', 'recommendation', function (authenticatedUser, permissionService, recommendation) {
                        return permissionService.hasPermission(recommendation.RecomBusinessUnit.FeatureRole, 'Observation', 'View');
                    }],
                    actionPlans: ['$stateParams', 'grcActionPlanService', function ($stateParams, service) {
                        return service.getActionPlansByRecommendation($stateParams.RecommendationID);
                    }],
                    businessUnit: function () {
                        return undefined;
                    },
                    lookupAttributes: ['grcRecommendationService', function (service) {
                        return service.getLookupAttributes();
                    }]
                },
                views: {
                    'mainContent@recommendation': {
                        controller: 'RecommendationEditController',
                        templateUrl: require('./recommendationEdit.tpl.html')
                    }
                }
            });

        // History Context
        historyCtxtServiceProvider.setCtxtState('recommendation.edit',
            '/app/Main/grcEdit/recommendation/GOVHistoryCtxtDirective-recommendation.tpl.html'
        );
    }
})();